import React,{useState} from 'react'

const Summer_2023 = ({data}) => {
 
  const [value, setValue] = useState();

  const handleChange = (e) => {
    setValue(e.target.value);
  };
  let uniqueList = [ ...new Set(data.map((currElem)=>{return currElem.Company;}))];
  uniqueList =uniqueList.sort();


    const newdata = data.filter((curr)=>{
      if(value === "All")
      {
        return data;
      }
      return curr.Company == value;
    })


  return (
<div>     
<div >
       
       <select className="test-div" style={{width:'800px',textTransform:'uppercase'}} value={value} onChange={handleChange}>
          <option className='mycomp' disabled selected value > -- Select a Company -- </option>
          <option className='mycomp' value="All">All Companies</option>
            {
              uniqueList.map((cur)=>{
                return (<option className='mycomp' value={cur}>{cur}</option>)
              })
            }
       </select>
      </div>
      <br />

     


    
    
    <div className='cardofstd'>
      {
        newdata.map((currElem)=>{
          var imageUrl = `../images/2023/${currElem.Roll}.webp`;
            const mailUrl = `mailto:${currElem.Personal}`

            return (
                 <div className='person'>

                    <div className="container card_box">
                        <div className="row card_box_in">
                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                                <div className="our-team1">
                                  <div className="picture">
                                    <img className="img-fluid" src={imageUrl}/>
                                  </div>
                                  <div className="team-content">
                                    <h4 className="name" style={{textTransform:"capitalize"}}>{currElem.Name}</h4>
                                    
                                    <h5 className="title">{currElem.Roll}</h5>
                                 <br />
                                    <h5 className="name">-: Company :- </h5>
                                    <h5 className="title" style={{textTransform:"capitalize"}}>{currElem.Company} </h5>
                                  </div>
                                  <br />
                                  <ul className="social">
                                    
                                    <li><a href={mailUrl} className="fa fa-envelope" aria-hidden="true" target="_blank"></a></li>
                                    <li><a href={currElem.Linkedin} className="fa fa-linkedin" aria-hidden="true" target="_blank"></a></li>
                                  </ul>
                                </div>
                              </div>
                              
                        </div>
                  </div>

              </div>
              
            )
        })
      }
    </div>
    </div>

  )
}

export default Summer_2023